import React from 'react';
import {Provider} from "components/citizen/CitizenContext";
import {CitizenList} from "components/citizen/CitizenList";

export const Citizens = () => {

    return (
        <Provider>
            <CitizenList/>
        </Provider>
    );
}
